




































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting, Theme} from '@/services/settings/Settings.types';

import SystemInfoStore from '@/store/system/SystemInfo.store';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class SystemInfoHardware extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private Setting = Setting;
  private Theme = Theme;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.systemInfoStore.fetchHardwareInfo();
      this.logger.info(`Hardware info data fetched`, this.systemInfoStore.HardwareInfo);
    } catch (error) {
      Notify.Error(this.logger, 'Could not load hardware info', error);
    } finally {
      this.setLoaded();
    }
  }

  private async copy(text: string) {
    await navigator.clipboard.writeText(text);

    Notify.Info(this.logger, 'The text has been copied to your clipboard');
  }
}
